/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The current status of the calendar connection after the update. Possible values: 'active' (connection is working), 'error' (connection has errors), 'revoked' (OAuth access was revoked), 'permission_denied' (insufficient permissions)
 */
export type UpdateCalendarConnectionResponseInputDataStatus =
  (typeof UpdateCalendarConnectionResponseInputDataStatus)[keyof typeof UpdateCalendarConnectionResponseInputDataStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCalendarConnectionResponseInputDataStatus = {
  active: "active",
  error: "error",
  revoked: "revoked",
  permission_denied: "permission_denied"
} as const
